import { ApiClientProps } from "hooks/useApi";

interface GetLocationFlagsParams {
    apiClient: ApiClientProps;
    locationId?: string;
    partnerId?: string;
}

const getLocationFlags = async ({
  apiClient,
  locationId,
  partnerId,
}: GetLocationFlagsParams) => {
    if (!locationId || !partnerId) {
        throw new Error("Location ID and Partner ID are required to fetch location flags.");
    }

    try {
        const response = await apiClient.get({
          path: `/middleware-admin/partners/${partnerId}/locations/${locationId}/flags`,
          noRetry: true,
        });

        return response;
    } catch (error) {
        throw new Error(error as string);
    }
    
};

export default getLocationFlags;